// ============================================
// FILE 6: /frontend/src/api/whatsapp.api.js
// PURPOSE: WhatsApp API client
// ============================================

import apiClient from './client.js';

export const whatsappAPI = {
  /**
   * Generate WhatsApp share message for single listing
   * @param {string} listingId - Listing ID
   * @returns {Promise<Object>} { message, whatsappUrl, trackingId }
   */
  generateShareMessage: async (listingId) => {
    console.log('[WhatsApp API] 📤 Generating share message for:', listingId);
    const response = await apiClient.post('/whatsapp/share', { listingId });
    console.log('[WhatsApp API] ✅ Share message generated');
    return response.data;
  },

  /**
   * Generate bulk WhatsApp message for multiple listings
   * @param {string[]} listingIds - Array of listing IDs
   * @returns {Promise<Object>} { message, whatsappUrl, trackingIds }
   */
  generateBulkMessage: async (listingIds) => {
    console.log('[WhatsApp API] 📤 Generating bulk message for:', listingIds.length, 'listings');
    const response = await apiClient.post('/whatsapp/bulk', { listingIds });
    console.log('[WhatsApp API] ✅ Bulk message generated');
    return response.data;
  },

  /**
   * Generate WhatsApp chat inquiry message
   * @param {string} listingId - Listing ID
   * @returns {Promise<Object>} { message, whatsappUrl, trackingId, sellerName }
   */
  generateChatMessage: async (listingId) => {
    console.log('[WhatsApp API] 💬 Generating chat message for:', listingId);
    const response = await apiClient.post('/whatsapp/chat', { listingId });
    console.log('[WhatsApp API] ✅ Chat message generated');
    return response.data;
  },

  /**
   * Track click from WhatsApp link (public endpoint)
   * @param {string} trackingId - Tracking ID from URL
   * @returns {Promise<Object>} { success: boolean }
   */
  trackClick: async (trackingId) => {
    console.log('[WhatsApp API] 📊 Tracking click:', trackingId);
    const response = await apiClient.post('/whatsapp/track-click', { trackingId });
    console.log('[WhatsApp API] ✅ Click tracked');
    return response.data;
  },

  /**
   * Get user's WhatsApp sharing analytics
   * @returns {Promise<Object>} { totalShares, totalClicks, topListings, etc }
   */
  getAnalytics: async () => {
    console.log('[WhatsApp API] 📈 Fetching analytics');
    const response = await apiClient.get('/whatsapp/analytics');
    console.log('[WhatsApp API] ✅ Analytics fetched');
    return response.data;
  }
};